export class AjaxErrorDetail {
    constructor(
        public readonly url: string,
        public readonly method: string,
        public readonly status: number,
        public readonly roundTrip: number,
        public readonly requestId: string,
    ) {
        this.url = url;
        this.method = method;
        this.status = status;
        this.roundTrip = roundTrip;
        this.requestId = requestId;
    }
}
